import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function recordProgress(filmId, position) {
  try {
    const body = { film_id: filmId };
    if (typeof position === "number" && position >= 0) body.position = position;
    await axios.post(`${API}/progress`, body, { withCredentials: true });
  } catch {
    /* not signed in or transient — ignore */
  }
}

export async function fetchProgress() {
  try {
    const { data } = await axios.get(`${API}/progress`, { withCredentials: true });
    return data.items || [];
  } catch {
    return [];
  }
}

export async function fetchFilmPosition(filmId) {
  try {
    const { data } = await axios.get(`${API}/progress/${filmId}`, { withCredentials: true });
    return Number(data.position) || 0;
  } catch {
    return 0;
  }
}
